import { render, staticRenderFns } from "./SlideGallery.vue?vue&type=template&id=4d4e63b8&scoped=true&"
import script from "./SlideGallery.vue?vue&type=script&lang=js&"
export * from "./SlideGallery.vue?vue&type=script&lang=js&"
import style0 from "./SlideGallery.vue?vue&type=style&index=0&id=4d4e63b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4e63b8",
  null
  
)

export default component.exports